import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPieSkeletonThreeQuarter = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 206,
	height: 220,
	viewBox: "0 0 206 220",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M95.5 11C95.5 4.92487 100.437 -0.0569855 106.482 0.549521C122.251 2.13169 137.538 7.10806 151.272 15.1873C168.177 25.1311 182.115 39.4136 191.644 56.5554C201.173 73.6972 205.945 93.0749 205.467 112.681C204.989 132.288 199.278 151.41 188.925 168.067C178.572 184.724 163.954 198.31 146.585 207.418C129.216 216.526 109.728 220.825 90.1391 219.869C70.5502 218.913 51.573 212.738 35.1733 201.982C21.8487 193.243 10.6193 181.739 2.21982 168.299C-0.999965 163.148 1.28161 156.515 6.72902 153.826C12.1765 151.137 18.7175 153.421 22.0651 158.49C28.6408 168.449 37.1959 176.999 47.2386 183.586C60.3584 192.19 75.5402 197.131 91.2113 197.895C106.882 198.66 122.473 195.221 136.368 187.935C150.263 180.648 161.958 169.779 170.24 156.453C178.522 143.128 183.091 127.83 183.474 112.145C183.856 96.4599 180.038 80.9577 172.415 67.2443C164.792 53.5309 153.641 42.1049 140.118 34.1498C129.766 28.0605 118.312 24.1745 106.472 22.6866C100.444 21.9292 95.5 17.0751 95.5 11Z",
		fill: "#F0EEED"
	})]
});
const ForwardRef = forwardRef(SvgPieSkeletonThreeQuarter);
export { ForwardRef as ReactComponent };
